import React, { useCallback, useState } from 'react';
import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import { Steps } from 'antd';
import { LeftOutlined } from '@ant-design/icons';
import CaptchaForm from './captcha-form';
import PasswordForm from './password-form';
import SuccessfulPage from './successful';
// import AppFooter from '@components/app-footer'
import { classNames } from '@src/utils';
import './password-reset.scss';
var prefixCls = 'password-reset-page';
var className = classNames('page', 'app-background', prefixCls);
var PasswordResetPage = function () {
    var location = useLocation();
    var _a = useState(0), step = _a[0], setStep = _a[1];
    var routematch = useRouteMatch();
    var path = routematch.path;
    var handleBack = useCallback(function () {
        if (Boolean(location.search) === true) {
            var url = location.search.split('url=')[1];
            window.location.href = "" + url;
        }
        else {
            window.location.href = "/login";
        }
    }, [location]);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: prefixCls + "_mark" }),
        React.createElement("div", { className: prefixCls + "_form-wrapper" },
            React.createElement(Switch, null,
                React.createElement(Route, { exact: true, path: path },
                    React.createElement("div", { className: prefixCls + "_header", key: "header" },
                        React.createElement("h4", { className: prefixCls + "_title" }, "\u91CD\u8BBE\u5BC6\u7801"),
                        React.createElement("div", { className: prefixCls + "_link", onClick: function () { return handleBack(); } },
                            React.createElement(LeftOutlined, null),
                            React.createElement("span", null, "\u8FD4\u56DE"))),
                    React.createElement("div", { className: prefixCls + "_content", key: "content" },
                        React.createElement(Steps, { className: prefixCls + "_steps", current: step, labelPlacement: "vertical", progressDot: true },
                            React.createElement(Steps.Step, { title: "\u9A8C\u8BC1\u624B\u673A\u53F7\u7801" }),
                            React.createElement(Steps.Step, { title: "\u8BBE\u7F6E\u65B0\u5BC6\u7801" }),
                            React.createElement(Steps.Step, { title: "\u5BC6\u7801\u91CD\u7F6E\u6210\u529F" })),
                        step === 0 ? (React.createElement(CaptchaForm, { className: prefixCls + "_form", onFinish: setStep })) : step === 1 ? (React.createElement(PasswordForm, { className: prefixCls + "_form" })) : null)),
                React.createElement(Route, { exact: true, path: path + "/successful" },
                    React.createElement(SuccessfulPage, null))))));
};
export default React.memo(PasswordResetPage);
